import * as types from './action-types';
import counterpart from 'counterpart';

export function changeLanguage (locale) {
  // todo: not sure this is the right place
  counterpart.setLocale(locale);

  return {
    type: types.CHANGE_LOCALE,
    payload: locale
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/i18n/index.js
 **/